import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import Header from './Header';

export default function PrivacyPolicy() {
  const { userId } = useParams(); 
  const contactEmail = "info@redish.com";

  return (
    <Container maxWidth="sm" sx={{ py: 2 }}>
      
      <Header userId={userId} />
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          Re:Dish Co. Privacy Policy
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          Last updated: September 30, 2025
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          1. General Privacy Policy Matters
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          At Re:Dish, we take privacy of our users very seriously. This Privacy Policy is a part of the Terms of Service for Dishlink, with respect to reusable dishware and payments for dishware items not returned.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          This Privacy Policy describes our policies on the collection, use, and disclosure of information that identifies, describes, relates to or is reasonably capable of being associated with you.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          The terms “we”, “us”, “our” and “Re:Dish” refer to Re:Dish Co. When you use the Service, you consent to our collection, use, and disclosure of information about you, including information that may be considered Personal Data, as described in this Privacy Policy.
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          2. Information We Collect
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          2.1 Personal Data Collect.  We collect and store the following information:
        </Typography>
        <Typography variant="body2">
          (a)	Your mobile phone number;
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        (b)	Your selected payment method and identifiers necessary to refer to that information as stored with the applicable payment processor;
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        (c)	The specific dishware items that you receive at the point of sale and the date and time you receive them;
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        (d)	Whether or not you return those items, and approximately when those items were returned;
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        (e)	Any payments you make for not returning dishware; and
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        (f)	The history of SMS messages and customer service inquiries between you and us.
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          3. How We Use Your Information
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}  >
          We use information about you to:
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
        (a)	Communicate with you about the dishware and the program, including any inquiries about customer or technical support;
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
        (b)	To charge your payment method for unreturned items, only if you do not return the dishware items;
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
        (c)	Notify you of technical updates or changes in policy;
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
        (d)	Collect aggregate statistics about use of the Service; and
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
        (e)	Analyze and develop our products and marketing strategy.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
          3.2 Opting Out of Receiving Communications. SMS messaging is an integral part of this program. However, you may opt out of non-essential messaging as explained in the Terms.
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          4.	Third Party Credit Card Processing
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
          <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">
            https://stripe.com/privacy
          </a>
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          5.	Sharing.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
          5.1 Sharing of Personal Data.  We may share information about you with the following third parties:
          </Typography>
          <Typography variant="body2" sx={{mt: 1}} >
          (a)	Service Providers: We share your Personal Data as necessary with third parties providing services to us in connection with this program. These third parties are subject to strict data processing terms and conditions and are prohibited from utilizing, sharing or retaining your Personal Data other than in accordance with these terms.
          </Typography>
          <Typography variant="body2" sx={{mt: 1}} >
            (b)	Corporate Affiliates: We may share information with our corporate affiliates, parents and/or subsidiaries.
          </Typography>
          <Typography variant="body2" sx={{mt: 1}} >
          We may also share information about you in the following contexts:
          </Typography>
          <Typography variant="body2" sx={{mt: 1}}>
          (d)	Pursuant to an Investigation: We may investigate and disclose information from or about you if we have a good faith belief that such investigation or disclosure (a) is reasonably necessary to comply with legal process and law enforcement instructions and orders, such as a search warrant, subpoena, statute, judicial proceeding, or other legal process served on us; (b) is helpful to prevent, investigate, or identify possible wrongdoing in connection with the Service; or (c) protects our rights, reputation, property, or that of our users, affiliates, or the public.
          </Typography>
          <Typography variant="body2" sx={{mt: 1}}>
          (e)	Pursuant to a Business Transfer: We may share information from or about you with our parent companies, subsidiaries, joint ventures, or other companies under common control, in which case we will require them to honor this Privacy Policy. If another company acquires us or all or substantially all of our assets, that company will possess the same information, and will assume the rights and obligations with respect to that information as described in this Privacy Policy.</Typography>
          <Typography variant="body2" sx={{mt: 1}}>
          (f)	As Anonymized Data: We frequently aggregate Personal Data in a way that makes it impracticable to use that data to identify a particular person; we also sometimes maintain individual data records with personal identifiers removed, and maintain in a manner in which it is impracticable to relink it to any particular individual. In this Privacy Policy, we refer to such data as “Anonymized Data” and do not consider it to be Personal Data. We may use Anonymized Data in order to create statistical information regarding the Service and its use, which we may then share with third parties. 
          </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          6.	Data Retention amd Account Termination
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          Users can request to have their account terminated by contacting us at {contactEmail}.  We will delete all Personal Data associated with your account within 3 days of termination.
        </Typography>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          7.	Security
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          We use commercially reasonable efforts to follow generally accepted industry standards to protect the Personal Data submitted to us, both during transmission and once we receive it. However, no method of transmission over the Internet or via mobile device, or method of electronic storage, is 100% secure. Therefore, while we strive to use commercially acceptable means to protect information about you, we cannot guarantee its absolute security.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          With respect to payment card information, we rely on our third party partners such as Stripe to collect, store and process that information in a manner consistent with PCI and other applicable standards.
        </Typography>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          8.	Modifications to this Privacy Policy.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          We may occasionally update this Privacy Policy. You can see when it was last updated by looking at the effective date at the top of this page. Each time you participate in this pilot program you acknowledge that your information and our practices will be subject to the then-current version of this Privacy Policy.
        </Typography>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          9.	Contact Information.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        If you have any further questions regarding our privacy practices or information about you, please feel free to contact us by email at the following address:
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          Re:Dish Co.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          {contactEmail}
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          10.	Data Protection Officer
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          Re:Dish has a data protection officer who is responsible for matters relating to privacy and data protection. Our data protection officer can be reached at the following email address: info@redish.com
        </Typography>
      </Box>
    </Container>
  );
}
